import '@digital-realty/ix-icon-button/ix-icon-button.js';
import { html, LitElement, nothing, TemplateResult } from 'lit';
import { property } from 'lit/decorators.js';

import FileInfo from './internal/file-info.js';
import IxFileChipStyles from './styles/ix-file-chip-styles.js';
import UploaderFile from './internal/uploader-file.js';
import { trash } from './assets/iconset.js';

export class IxFileChip extends LitElement {
  static readonly styles = [IxFileChipStyles];

  @property({ type: Object }) file?: UploaderFile;

  @property({ type: Boolean }) deletable: boolean = true;

  private onClick(): void {
    const event = new CustomEvent<FileInfo>('on-file-click', {
      detail: {
        file: this.file,
      },
    });

    this.dispatchEvent(event);
  }

  private onDelete(): void {
    if (this.deletable) {
      const event = new CustomEvent<FileInfo>('on-file-delete', {
        detail: {
          file: this.file,
        },
      });

      this.dispatchEvent(event);
    }
  }

  protected render(): TemplateResult<1> {
    return html`<li class="file-chip">
      <span @click=${this.onClick}> ${this.file?.name} </span>

      ${this.deletable
        ? html`<ix-icon-button @click=${this.onDelete} name="delete-button">
            <ix-icon slot="default" class="delete-icon"> ${trash} </ix-icon>
          </ix-icon-button>`
        : nothing}
    </li>`;
  }
}
